import fetchAddressFromGeoCode from 'shared/utils/fetchAddressFromGeoCode';

export const setAddressInState = (
    addressComponents: google.maps.GeocoderAddressComponent[],
    latlng: google.maps.LatLng | null,
    setFieldValue: Function,
    locationIndex: number | string
) => {
    const { streetLocality, country, province, city, pinCode } =
        fetchAddressFromGeoCode(addressComponents);

    setFieldValue(
        `locations[${locationIndex}].street`,
        streetLocality?.trim() ?? ''
    );
    setFieldValue(
        `locations[${locationIndex}].country`,
        country?.long_name ?? ''
    );
    setFieldValue(
        `locations[${locationIndex}].countryCode`,
        country?.short_name ?? ''
    );
    setFieldValue(
        `locations[${locationIndex}].province`,
        province?.long_name ?? ''
    );
    setFieldValue(
        `locations[${locationIndex}].provinceCode`,
        province?.short_name ?? ''
    );
    setFieldValue(`locations[${locationIndex}].city`, city?.long_name ?? '');
    setFieldValue(
        `locations[${locationIndex}].postalCode`,
        pinCode?.long_name ?? ''
    );
    setFieldValue(`locations[${locationIndex}].latitude`, latlng?.lat() ?? '');
    setFieldValue(`locations[${locationIndex}].longitude`, latlng?.lng() ?? '');
};